"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CookieSettings = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require("./CookieSettings"))));
const Settings = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require("./Setting"))));
const CookieSetting = _ref => {
  let {
    privacyPolicyLink = "",
    configUrl = "",
    showSettingPage = false,
    analytics = "",
    pathSpecific = true
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null)
  }, showSettingPage ? /*#__PURE__*/_react.default.createElement(Settings, {
    privacyPolicyLink: privacyPolicyLink,
    configUrl: configUrl,
    analytics: analytics,
    pathSpecific: pathSpecific
  }) : /*#__PURE__*/_react.default.createElement(CookieSettings, {
    privacyPolicyLink: privacyPolicyLink,
    configUrl: configUrl,
    analytics: analytics,
    pathSpecific: pathSpecific
  }));
};
var _default = exports.default = CookieSetting;